import { useSetFilter } from '../../filter';
import { RoutineOrderKey } from '../domain';

export const useSetRoutineListOrder = () => {
  return useSetFilter(RoutineOrderKey, 'routineOrderBy', true);
};
